import interceptorAxios from './InterceptorAxios';
const ServicioParametros = {
    paginacion(objeto){
        return interceptorAxios.post('/parametros/paginacion.json',objeto);
    },
    guardar(objeto){
        return interceptorAxios.post('/parametros/guardar.json',objeto);
    },
    actualizar(objeto){
        return interceptorAxios.post('/parametros/actualizar.json',objeto);
    }
}
export default ServicioParametros;

